<div class="dialog-padding">
  <h1 mat-dialog-title>Apply a Refund</h1>
  <div mat-dialog-content>
    <form #newCustomerServiceNoteForm="ngForm" id="refundForm">
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>
        <input
          class="form-control"
          matInput
          uzCurrencyInput
          ciCurrencyCode="USD"
          [(ngModel)]="refundPayment.amount"
          id="refundPayment.amount"
          name="refundPayment.amount"
          required
        />
      </mat-form-field>
      <!-- commenting out because the backend doesnt support yet-->
      <!-- <mat-form-field class="description-field" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          width="300"
          height="300"
          class="form-control"
          matInput
          [(ngModel)]="refundPayment.paymentDescription"
          id="refundPayment.paymentDescription"
          name="refundPayment.paymentDescription"
        >
        </textarea>
      </mat-form-field> -->
    </form>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>&nbsp;
    <button
      mat-raised-button
      color="primary"
      uzDebounceClick
      (debounceClick)="handleRefund($event)"
      [disabled]="!(refundPayment.amount > 0 && refundPayment.amount <= originalPayment.amount)"
    >
      Refund
    </button>
  </div>
</div>
